export default __webpack_public_path__ + "locales/sl/JavascriptSdk.json?hash=3f3fea690ccd263e9c2af6e5bbe95035";